import { Theme } from '@mui/material';

const Tabs = (theme: Theme) => {
  return {
  };
};

export default Tabs;
